import { type ReactNode } from 'react';

import styles from './PublisherDesktopLayout.css';

type TPublisherDesktopLayoutProps = {
  publisher: ReactNode;
  controls: ReactNode;
  publicationDate: ReactNode;
  promotionDescription: ReactNode;
};

export function PublisherDesktopLayout({
  publisher,
  controls,
  publicationDate,
  promotionDescription,
}: TPublisherDesktopLayoutProps): ReactNode {
  return (
    <div className={styles['container']} data-testid="publisher.desktop-layout">
      <div className={styles['content-top']}>
        <div className={styles['publisher']}>{publisher}</div>
        <div className={styles['controls-wrapper']}>{controls}</div>
      </div>
      <div className={styles['content-bottom']}>
        <div className={styles['publication-date']}>{publicationDate}</div>
        <div className={styles['promotion-description']}>{promotionDescription}</div>
      </div>
    </div>
  );
}
